export const en: Record<string, string> = {
  // ---------- Tabs ----------
  "tabs.dashboard": "Dashboard",
  "tabs.charts": "Charts",
  "tabs.records": "Records",
  "tabs.shifts": "Shifts",
  "tabs.people": "People",
  "tabs.settings": "Settings",
  "tabs.report": "Report",
  "tabs.emergency": "Emergency",
  "tabs.my_records": "My records",
  "tabs.turbines": "Turbines",
  "tabs.automatika": "Automation",
  "tabs.power_analyzer": "Power Analyzer",
  "tabs.scada": "SCADA",
  "tabs.scada_v2": "Automation v2",
  "tabs.combined": "Overall",
  "tabs.incidents": "Incidents",
  "incidents.pick": "Event",
  "incidents.trip": "Trip",
  "incidents.onset": "Out-of-band onset",
  "incidents.window": "Data window",
  "incidents.kpi_umax": "U max",
  "incidents.kpi_kwmax": "P max",
  "incidents.kpi_qmax": "Q max",
  "incidents.kpi_hz": "f min–max",
  "incidents.kpi_oob": "Out of band",
  "incidents.kpi_alarms": "Alarms",
  "incidents.sec": "sec",
  "incidents.chart_v": "Line voltages RS / ST / RT",
  "incidents.chart_p": "Power and frequency",
  "incidents.chart_pos": "Turbine speed and guide vane",
  "incidents.kpi_speed": "Speed max",
  "incidents.speed_label": "n — turbine speed, %",
  "incidents.pos_label": "GV — guide vane, %",
  "incidents.metrics_n": "metrics",
  "incidents.diff_label": "Differential protection (87H)",
  "incidents.q1_label": "Breaker Q1 (cell H01)",
  "incidents.fired": "fired at",
  "incidents.pre_label": "Deviations before the trip",
  "incidents.grp_power": "Power",
  "incidents.grp_voltage": "Voltage",
  "incidents.grp_current": "Current",
  "incidents.grp_temperature": "Temperatures",
  "incidents.grp_pressure": "Pressure",
  "incidents.grp_level": "Levels",
  "incidents.grp_control": "Control",
  "incidents.grp_counter": "Counters",
  "incidents.marker_trip": "trip",
  "incidents.marker_onset": "out-of-band onset",
  "incidents.alarms_title": "Alarm log (EN + RU)",
  "incidents.col_ru": "Alarm (Russian)",
  "incidents.table_title": "Per-second data",
  "incidents.table_note": "All telemetry metrics. ◆ — trip second; ⚠ amber — pre-fault deviations (deviating values highlighted in the row); red — voltage above band; orange — turbine overspeed; ⬥/▮ — differential/Q1. Scrolls horizontally; the time column is pinned.",
  "combined.title": "Overall picture — all data",
  "combined.max_kw": "Peak power",
  "combined.total_energy": "Total energy",
  "combined.total_run": "Uptime (all)",
  "combined.by_source": "By data source",
  "combined.sharp_title": "Sharp voltage spikes — top 5-min windows",
  "combined.sharp_hint": "5-min windows sorted by count of sudden second-to-second jumps ≥{kv} kV. Tap → seconds",
  "combined.prolonged_title": "Prolonged excursions — top 5-min windows",
  "combined.prolonged_hint": "Windows sorted by the longest continuous run outside the {lo}–{hi} kV corridor (from {s} s). Tap → seconds",
  "combined.detail_hint": "Window ±10 s · {sharp} sharp seconds · {oob} out-of-band seconds",
  "combined.legend_sharp": "sharp seconds (|Δ|≥1 kV)",
  "combined.legend_band": "reference band",
  "combined.col_time": "Time",
  "combined.sub_overview": "Overview",
  "combined.sub_vband": "Band {lo}–{hi}",
  "vband.period": "Period",
  "vband.all": "All time",
  "vband.days": "d",
  "vband.hours": "h",
  "vband.data": "Data",
  "vband.bucket": "bucket",
  "vband.in_band": "In band",
  "vband.above": "Above",
  "vband.below": "Below",
  "vband.min_unit": "min",
  "vband.chart_title": "R / S / T inside the {lo}–{hi} kV corridor",
  "vband.chart_hint": "Green zone = the {lo}–{hi} kV norm. Differently coloured dots mark excursions: red above {hi} kV, blue below {lo} kV. Only loaded minutes count (a stopped unit reads 0 kV).",
  "vband.by_phase": "By phase",
  "vband.phase": "Phase",
  "vband.excursions": "Excursions",
  "vband.peak": "Peak, kV",
  "vband.dur": "Duration",
  "vband.dir": "Direction",
  "vband.exc_hint": "Ranked by deviation size. 📈 — per-second telemetry of that moment.",
  "vband.no_dev": "No excursions",
  "combined.sub_drill": "Table",
  "combined.sub_alarms": "Alarms",
  "combined.event_hint": "Alarm moment {at} (±45 s). ◆ = the event second; red dots = sharp jumps",
  "combined.no_telemetry": "No telemetry for this moment",
  "combined.unit_stopped": "The unit was stopped at this moment (voltage & power = 0)",
  "combined.zero_legend": "🟡 Yellow — unit was off (zeros only)",
  "combined.moment": "alarm moment",
  "combined.drill_source": "Source",
  "alarms.total": "Total alarms",
  "alarms.active_now": "Active now",
  "alarms.not_acked": "Not acknowledged",
  "alarms.records": "records",
  "alarms.by_unit": "By unit",
  "alarms.by_category": "By category",
  "alarms.period": "Period",
  "alarms.filter_unit": "Unit",
  "alarms.all": "All",
  "alarms.active_only": "Active only",
  "alarms.leaderboard": "Top alarm types",
  "alarms.leaderboard_hint": "Ranked by occurrence count. Tap → all occurrences of this alarm",
  "alarms.active_short": "active",
  "alarms.last": "last",
  "alarms.occurrences": "occurrences",
  "alarms.all_periods": "All periods",
  "alarms.of_total": "of {n} total",
  "alarms.none_with_data": "No occurrences with telemetry (station was off or no data)",
  "alarms.cat.TRIP": "Trip",
  "alarms.cat.VOLTAGE_MISS": "Voltage miss",
  "alarms.cat.COMM_LOST": "Comm lost",
  "alarms.cat.LUBRICATION": "Lubrication",
  "alarms.cat.POWER_SUPPLY": "Power supply",
  "alarms.cat.AUTH": "Auth",
  "alarms.cat.SYSTEM": "System",
  "alarms.cat.OTHER": "Other",
  "minmax.min": "min",
  "minmax.max": "max",
  "alarms.show_telemetry": "Telemetry",
  "alarms.filter_cat": "Category",
  "alarms.log_title": "Alarm log",
  "alarms.col_unit": "Unit",
  "alarms.col_msg": "Message",
  "alarms.load_more": "Load more",
  "tabs.users": "Users",
  "users.title": "Users",
  "users.create_invite": "➕ Create invite link",
  "users.invite_hint": "One-time link, valid 7 days. Send it to the person — they open it and get view-only access.",
  "users.link_label": "Invite link (tap to copy):",
  "users.copy": "Copy",
  "users.copied": "Copied",
  "users.none": "No invited users yet.",
  "users.col_user": "User",
  "users.col_status": "Status",
  "users.col_joined": "Joined",
  "users.col_tabs": "Sections",
  "users.invite_tabs": "Sections this user will see:",
  "users.invite_name": "Name (so you know who it is):",
  "users.name_placeholder": "e.g. Ivan — shift 2",
  "users.delete": "Delete",
  "users.delete_confirm": "Delete {name}? They will lose access and the bot will stop processing them.",
  "users.active": "active",
  "users.inactive": "off",
  "users.deactivate": "Deactivate",
  "users.activate": "Activate",

  // ---------- Автоматика (SCADA telemetry) ----------
  "auto.sub_overview": "Overview",
  "auto.sub_charts": "Charts",
  "auto.sub_anomalies": "Deviations",
  "auto.sub_jumps": "Jumps",
  "auto.sub_minmax": "Min/Max",
  "auto.oob_n": "{n} out of band",
  "auto.dev_by_line": "Deviations by line",
  "auto.dev_short": "dev.",
  "auto.dev_day": "Day",
  "auto.dev_total": "Total for period",
  "auto.dev_band": "band",
  "auto.v_line": "Line voltage",
  "auto.v_phase": "Phase voltage",
  "minmax.bucket": "Interval",
  "minmax.sec": "per second",
  "minmax.time": "Time",
  "minmax.hint": "Tap a row to drill in (hour → 5 min → minute). Red = outside {lo}–{hi} kV.",
  "minmax.hint_leaf": "Per-minute min/max. Red = outside {lo}–{hi} kV.",
  "jumps.hint": "Sudden step-changes between adjacent readings (sharp up/down). {n} found.",
  "jumps.none": "No sharp jumps found.",
  "auto.sub_data": "Data",
  "auto.all": "All",
  "auto.last_3d": "Last 3 days",
  "auto.last_1d": "Last day",
  "auto.data_range": "Data",
  "auto.timeframe": "Timeframe",
  "auto.tf_all": "All data",
  "auto.tf_7d": "Last 7 days",
  "auto.tf_3d": "Last 3 days",
  "auto.tf_1d": "Last 24 hours",
  "auto.tf_12h": "Last 12 hours",
  "auto.tf_6h": "Last 6 hours",
  "auto.tf_1h": "Last hour",
  "auto.tf_custom": "Custom range…",
  "auto.hide_zeros": "Hide zeros",
  "auto.truncated": "showing top 500",
  "auto.tap_for_details": "Tap for full snapshot",
  "auto.snapshot_title": "📸 State at this moment",
  "auto.resolution": "Resolution",
  "auto.res_auto": "Auto",
  "auto.res_raw": "Per-second",
  "auto.reset_zoom": "Reset zoom",
  "auto.deviations_n": "{n} flagged",
  "auto.drill_hint": "Tap any point to zoom in; or drag the bottom slider and tap “Zoom to selection”. Red points had a deviation in that interval.",
  "auto.zoom_to_sel": "Zoom to selection",
  "auto.back": "← Back",
  "charts.overlay": "Overlay",
  "charts.overlay_none": "none",
  "charts.right_axis": "right axis",
  "auto.filter_metric": "Filter by metric",
  "auto.all_metrics": "All metrics",
  "auto.minutes": "min",
  "auto.min_short": "min",
  "auto.bucket": "bucket",
  "auto.kpi_running": "Running",
  "auto.kpi_peak_power": "Peak power",
  "auto.kpi_avg": "avg",
  "auto.kpi_span": "Period",
  "auto.kpi_energy": "Energy produced",
  "auto.kwh": "kWh",
  "auto.mwh": "MWh",
  "auto.col_metric": "Metric",
  "auto.no_anomalies": "No notable deviations in this period.",
  "auto.anomalies_hint": "{n} events (≥ {floor}% off normal, beyond ±2σ over running periods).",
  "auto.off_normal": "off normal",
  "auto.normal": "normal",
  "auto.when": "when",
  "auto.upload_title": "Upload a station CSV",
  "auto.upload_hint": "Space-separated SCADA export (.csv or .gz). Large files: upload .gz. Ingested in the background; data is separate from manual readings.",
  "auto.uploading": "Uploading…",
  "auto.upload_started": "Upload received — ingesting in the background…",
  "auto.upload_done": "Done — {rows} rows ingested.",
  "auto.upload_error": "Ingestion failed — check the file format.",
  "auto.export_xlsx": "📥 Download Excel (range)",
  "auto.export_hint": "Raw 1-sec rows for the selected period, original columns, one sheet per day.",
  "auto.imports_title": "Uploads",
  "auto.col_file": "File",
  "auto.col_status": "Status",
  "auto.col_rows": "Rows",
  "auto.col_period": "Period",

  // ---------- Turbines ----------
  "turbines.title": "🏭 Turbines",
  "turbines.empty_for_station": "Your station has no turbines yet. Ask an admin.",
  "turbines.none_for_station": "No turbines.",
  "turbines.active": "active",
  "turbines.inactive": "inactive",
  "turbines.status_running": "running",
  "turbines.status_stopped": "stopped",
  "turbines.status_off": "off",
  "turbines.activate": "Activate",
  "turbines.deactivate": "Deactivate",
  "turbines.state_running": "Running",
  "turbines.state_stopped": "Stopped",
  "turbines.state_off": "Out of service",
  "turbines.start_btn": "Start",
  "turbines.start_sub": "Record start with current KV",
  "turbines.start_title": "Start {name}",
  "turbines.confirm_start": "Start",
  "turbines.stop_btn": "Stop",
  "turbines.stop_sub": "Record stop with KW, time and reason",
  "turbines.stop_title": "Stop {name}",
  "turbines.confirm_stop": "Stop",
  "turbines.stop_time": "Time of stop",
  "turbines.stop_reason": "Reason",
  "turbines.stop_reason_placeholder": "Why was the turbine stopped?",
  "turbines.recent_events": "Event history",
  "turbines.evt_start": "Start",
  "turbines.evt_stop": "Stop",
  "turbines.tab_list": "Turbines",
  "turbines.tab_history": "History",
  "turbines.no_events": "No events yet.",
  "turbines.fill_btn": "Fill report",
  "turbines.fill_sub": "Log readings for this turbine",
  "turbines.fill_sub_offline": "Turbine stopped — entry will be orange",

  // ---------- Common ----------
  "common.loading": "Loading…",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.create": "Create",
  "common.close": "Close",
  "common.retry": "Retry",
  "common.back": "Back",
  "common.add": "Add",
  "common.submit": "Submit",
  "common.no_changes": "No changes",
  "common.saved": "Saved",
  "common.copied": "Copied",
  "common.copy_link": "📋 Copy link",
  "common.no_data": "No data for the selected period.",
  "common.empty": "Nothing here yet.",
  "common.error_generic": "Something went wrong. Try again.",
  "common.no_connection": "No connection to the server",
  "common.timeout": "Server not responding — try again",

  // ---------- Access / desktop hint ----------
  "access.locked_title": "Access denied",
  "access.locked_hint": "Only registered users can open this app. Ask an administrator for an invite link.",
  "desktop_hint.title": "Open in Telegram",
  "desktop_hint.body": "This is a Telegram Mini App. Open the bot in your phone or desktop Telegram and tap 📱 next to the input.",

  // ---------- Periods ----------
  "period.today": "Today",
  "period.yest": "Yesterday",
  "period.7d": "7 days",
  "period.30d": "30 days",
  "period.all": "All",

  // ---------- Status / types ----------
  "status.completed": "✅",
  "status.miss_short": "miss",
  "type.plan": "Plan",
  "type.emergency": "🚨 Emergency",
  "type.missed": "🚫 Missed",
  "type.late": "🟨 Late",
  "type.offline": "🟠 Offline",
  "filter.all": "All",

  // ---------- Charts ----------
  "charts.title": "📈 Charts",
  "charts.select_chart": "Select a chart",
  "charts.turbine": "Turbine",
  "charts.period": "Period",
  "charts.kw_kv_label": "KW & KV fluctuations",
  "charts.kw_kv_title": "KW & KV over time",
  "charts.kw_kv_hint": "Two lines: KW (left axis) and KV (right axis). Voltage spikes are easy to spot.",
  "charts.kw_kv_offline_title": "KW & KV trend (turbine stopped)",
  "charts.kw_kv_offline_hint": "Only records taken while the turbine was stopped. KW (orange, left axis) and KV (purple, right axis).",

  "charts.compare_label": "Compare turbines (KW)",
  "charts.compare_hint": "Power curves of all turbines on one chart. Useful for spotting uneven load distribution and idle turbines.",

  "charts.timeline_label": "Run / downtime timeline",
  "charts.timeline_hint": "Horizontal bars per turbine: green segments = running, red = stopped. The whole downtime for the period fits on one screen.",
  "charts.timeline_running": "Running",
  "charts.timeline_stopped": "Stopped",

  "charts.temperatures_label": "BT temperatures",
  "charts.temperatures_hint": "Temperature sensors BT 371, BT 372, BT 331, BT 332 on a single chart. A sharp spike means overheating risk.",

  "charts.frequency_label": "Frequency (Hz)",
  "charts.frequency_hint": "Generation frequency in Hz with reference lines at 49.5 and 50.5. Any deviation over 0.5 Hz means a grid problem.",
  "charts.freq_low": "49.5 Hz (low)",
  "charts.freq_high": "50.5 Hz (high)",

  "charts.stop_reasons_label": "Stop reasons",
  "charts.stop_reasons_hint": "Distribution of reason fields from turbine Stop events. Shows which problems happen most often and where to focus.",
  "charts.stop_reasons_empty": "No turbine stops in this period.",
  "charts.reason_unknown": "Unspecified",

  "charts.kw_histogram_label": "KW distribution (histogram)",
  "charts.kw_histogram_hint": "How many readings fell into each 200-KW bucket. Reveals the operating mode the turbine spends most of its time in.",

  "charts.cos_kvar_label": "cos φ and Kvar",
  "charts.cos_kvar_hint": "Power factor cos φ (left axis, 0..1) and reactive power Kvar (right axis). Dropping cos φ = generation quality issues.",

  "charts.pressure_label": "Pressures (BP 371, Bar, Pipe pressure)",
  "charts.pressure_hint": "All pressures on one chart. Sharp swings indicate emergency conditions in the hydraulic or steam loop.",

  "charts.scatter_label": "KW vs KV (scatter)",
  "charts.scatter_hint": "Scatter plot, each dot = one reading. Shows correlation between power and voltage; outliers stand out.",

  "analysis.title": "Analysis",
  "analysis.no_data": "Not enough data in this period to analyse.",
  "analysis.records": "Records considered: {n}.",

  "analysis.kv_ok": "Voltage within normal range (KV {min}–{max}, target 17–22).",
  "analysis.kv_out": "Voltage outside normal range (KV {min}–{max}, expected 17–22). Check grid status.",
  "analysis.kw_stable": "Power output is stable, average {avg} KW.",
  "analysis.kw_unstable": "Power output unstable: spread is {cv}% of the {avg} KW average. Inspect the load.",

  "analysis.turbine_idle": "{name}: no data in this period — turbine was idle.",
  "analysis.turbine_avg": "{name}: average power {avg} KW.",
  "analysis.compare_balanced": "Load is evenly distributed across turbines.",
  "analysis.compare_imbalance": "Load imbalance: {hi} ({hiAvg} KW) significantly higher than {lo} ({loAvg} KW).",

  "analysis.timeline_overall": "Combined uptime across all turbines: {uptime}%. Total stops: {stops}.",
  "analysis.timeline_turbine": "{name}: running {uptime}% of the time, downtime {downtime}.",

  "analysis.temp_ok": "Temperatures normal, max {max}°C (threshold 70°C).",
  "analysis.temp_warn": "Elevated temperature, max {max}°C. Normal up to 70°C, critical above 85°C — watch the sensors.",
  "analysis.temp_critical": "Overheating! Max {max}°C on sensors: {sensors}. Attention required.",
  "analysis.temp_avg": "Average temperature: {avg}°C.",

  "analysis.freq_ok": "Frequency stable: {min}–{max} Hz, within the 49.5–50.5 normal band.",
  "analysis.freq_bad": "Frequency went out of range: below 49.5 — {low} points, above 50.5 — {high} (of {total}).",
  "analysis.freq_avg": "Average frequency: {avg} Hz.",

  "analysis.stop_none": "No turbine stops in this period — excellent.",
  "analysis.stop_total": "Total stops: {n}.",
  "analysis.stop_top": "Most common reason: «{name}» ({pct}%).",
  "analysis.stop_dominant": "One reason dominates: «{name}» ({pct}% of all stops). Worth investigating the source.",
  "analysis.stop_variety": "Variety of reasons: {n} distinct categories.",

  "analysis.hist_top": "Most often power is in the {range} KW band ({pct}%).",
  "analysis.hist_low": "{pct}% of records at low power — frequent under-loading.",
  "analysis.hist_normal": "{pct}% of time running at normal load.",
  "analysis.hist_avg": "Average power: {avg} KW.",

  "analysis.cos_ok": "cos φ normal (avg {avg}). High generation quality.",
  "analysis.cos_warn": "cos φ reduced (avg {avg}). Normal ≥0.95, reactive-power compensation recommended.",
  "analysis.cos_bad": "cos φ low (avg {avg}). Significant losses — under-loading or large reactive load.",
  "analysis.kvar_avg": "Kvar: avg {avg}, range {min}–{max}.",

  "analysis.pressure_field": "{name}: avg {avg}, range {min}–{max}.",

  "analysis.scatter_few": "Too few points to analyse correlation.",
  "analysis.scatter_points": "{n} points on the chart.",
  "analysis.scatter_corr_pos": "Strong positive correlation between KW and KV (r={r}). Voltage rises with power.",
  "analysis.scatter_corr_neg": "Strong negative correlation between KW and KV (r={r}). Voltage drops as power rises.",
  "analysis.scatter_corr_none": "No clear correlation between KW and KV (r={r}).",

  // ---------- Dashboard ----------
  "dashboard.title": "📊 Dashboard",
  "dashboard.kpi.completed": "Completed",
  "dashboard.kpi.completed_sub": "{pct}% of plan",
  "dashboard.kpi.total": "Total slots",
  "dashboard.kpi.missed": "🚫 Missed",
  "dashboard.kpi.late": "🟨 Late",
  "dashboard.kpi.emergency": "🚨 Emergency",
  "dashboard.kpi.avg_response": "Avg response",
  "dashboard.kpi.avg_response_sub": "From notification to start",
  "dashboard.kpi.avg_kw": "Average KW",
  "dashboard.kpi.avg_kv": "Average KV",
  "dashboard.kpi.min_max_sub": "min / max for the period",
  "dashboard.kpi.min": "min",
  "dashboard.kpi.max": "max",
  "dashboard.turbines.downtime": "Downtime",
  "dashboard.turbines.last_reading": "Last reading",
  "dashboard.turbines.no_downtime": "No downtime",
  "dashboard.turbines.no_data": "no data",
  "dashboard.turbines.just_now": "just now",
  "dashboard.turbines.ago": "ago",
  "dashboard.turbines.unit_d": "d",
  "dashboard.turbines.unit_h": "h",
  "dashboard.turbines.unit_min": "min",
  "dashboard.sparkline.title": "KW trend, last 24 h",
  "dashboard.sparkline.hint": "All online power readings across both turbines",
  "dashboard.distribution.title": "Slot distribution",
  "dashboard.distribution.on_time": "✅ On time",
  "dashboard.distribution.late": "🟨 Late",
  "dashboard.distribution.missed": "🚫 Missed",
  "dashboard.distribution.pending": "⏳ In progress",
  "dashboard.distribution.emergency": "🚨 Emergency",
  "dashboard.by_day.title": "Completion by day, %",
  "dashboard.by_day.tooltip": "{pct}% ({completed}/{total})",
  "dashboard.by_day.tooltip_label": "Completion",
  "dashboard.by_hour.title": "Completion by hour of day",
  "dashboard.by_hour.legend": "🟢 high · 🟡 mid · 🔴 low",
  "dashboard.by_hour.legend_count": "Number of reports submitted in each hour of the day (across the period).",
  "dashboard.by_hour.no_data": "no data",
  "dashboard.users.title": "Operator ranking",
  "dashboard.users.col_name": "Name",
  "dashboard.users.col_avg": "Avg response",
  "dashboard.users.bar_title": "Average response time, sec",
  "dashboard.empty": "No data for the selected period. Try another period or wait for the next hourly tick.",

  // ---------- Records (admin) ----------
  "records.title": "📋 Records",
  "records.from": "From",
  "records.to": "To",
  "records.download_xlsx": "📥 Download Excel",
  "records.xlsx_per_day": "Each day in the range becomes its own sheet (per the readings ledger).",
  "records.custom_preview": "🛠 Custom preview",
  "records.col_date": "Date",
  "records.col_turbine": "Turbine",

  "custom_preview.title": "🛠 Custom preview",
  "custom_preview.period": "Period",
  "custom_preview.turbine": "Turbine",
  "custom_preview.type": "Record type",
  "custom_preview.fields": "Selected: {n} of {total}",
  "custom_preview.select_all": "Select all",
  "custom_preview.clear": "Clear",
  "custom_preview.build_btn": "Build table",
  "custom_preview.building": "Building…",
  "custom_preview.rows_count": "Total rows: {n}",
  "custom_preview.sort_hint": "Click to sort",
  "records.col_slot": "Slot",
  "records.col_who": "Who",
  "records.col_type": "Type",
  "records.col_status": "Status",
  "records.detail.title": "Record #{id}",
  "records.detail.slot": "Slot",
  "records.detail.responsible": "Responsible",
  "records.detail.started": "Started",
  "records.detail.completed": "Completed",
  "records.detail.response": "Response",
  "records.detail.fill": "Fill time",
  "records.detail.reason": "Reason",
  "records.detail.seconds": "s",

  // ---------- My records (responsible) ----------
  "my_records.title": "📋 My records",
  "my_records.download_xlsx": "📥 Download Excel",

  // ---------- Shifts (admin) ----------
  "shifts.title": "📅 Shifts",
  "shifts.choose_user": "Choose a responsible",
  "shifts.fill_range": "📐 Fill range",
  "shifts.active_count": "Active shifts ({n})",
  "shifts.empty": "No shifts yet. Tap a day in the calendar.",
  "shifts.range.title": "📐 Fill range",
  "shifts.range.from": "Start",
  "shifts.range.to": "End",
  "shifts.range.invalid": "End date is before start date",
  "shifts.range.added": "Added: {added}, skipped: {skipped}",
  "shifts.deactivated": "deactivated",
  "shifts.more_hidden": "…and {n} more (hidden)",

  // ---------- People & stations ----------
  "people.title": "👥 People and stations",
  "people.stations": "🏭 Stations ({n})",
  "people.add_station": "➕ Add station",
  "people.station.name": "Name",
  "people.station.city": "City",
  "people.station.tz": "Timezone (Europe/Kyiv)",
  "people.station.new_title": "New station",
  "people.station.name_placeholder": "Name (e.g. Energo-2)",
  "people.station.confirm_delete": "Delete station «{name}»?",
  "people.station.fill_required": "Fill name and city",
  "people.invite.title": "New invite",
  "people.invite.placeholder": "Operator's full name",
  "people.invite.create": "➕ Create invite",
  "people.invite.created_for": "✅ Invite for «{name}»",
  "people.invite.copy_failed": "Couldn't copy. Select the link manually.",
  "people.list_title": "Responsibles ({n})",
  "people.list_empty": "No one yet. Create an invite.",
  "people.deactivate": "Deactivate",
  "people.activate": "Activate",
  "people.station_label": "Station:",
  "people.station_none": "— no station —",

  // ---------- Settings ----------
  "settings.title": "⚙ Settings",
  "settings.notification_interval": "Notification interval, min ({min}–{max})",
  "settings.notification_hint": "Every {n} minutes operators get a Telegram ping. Applies from the next tick.",
  "settings.range_error": "Allowed range: {min}–{max}",
  "settings.language": "Language",
  "settings.trigger_running": "Running…",
  "settings.trigger_label": "⚡ Trigger: fire hourly tick",
  "settings.trigger_success": "✅ Tick fired. Operators on shift will receive notifications.",
  "settings.trigger_failed": "⚠ {error}",

  // ---------- Report (responsible landing) ----------
  "report.title": "📝 Report",
  "report.ready_to_fill": "Ready to submit. Tap the button below.",
  "report.no_slot": "⏳ Submission unavailable",
  "report.no_slot_hint": "Turbine is stopped or you are on a day off.",
  "report.day_off": "🌴 You are on a day off today",
  "report.day_off_hint": "Notifications are paused until the end of the shift.",
  "report.fill_btn": "Fill report",
  "report.fill_btn_offline": "Fill (turbine stopped)",
  "report.fill_sub_active": "Plan readings for the current hour",
  "report.fill_sub_disabled": "Not available right now",
  "report.fill_sub_day_off": "Unavailable — day off",
  "report.fill_sub_offline": "Entry will be flagged orange",
  "report.emergency_btn": "Emergency",
  "report.emergency_sub": "Unplanned entry: KW + KV",
  "report.day_off_btn_off": "Day off",
  "report.day_off_btn_on": "Cancel day off",
  "report.day_off_sub_off": "Mark today as a non-working day",
  "report.day_off_sub_on": "Resume shift notifications",
  "report.day_off_confirm_on": "Mark today as a day off? You will stop receiving notifications for this shift.",
  "report.day_off_confirm_off": "Cancel day off — notifications will resume?",

  // ---------- Report form ----------
  "report_form.title": "📋 Plan report",
  "report_form.slot_label": "Slot",
  "report_form.placeholder_pair": "X or X/Y",
  "report_form.placeholder_single": "—",
  "report_form.filled_count": "Filled {n} of {total}. Partial submit is allowed.",
  "report_form.expand_all": "Expand all",
  "report_form.collapse_all": "Collapse all",
  "bool.on": "On",
  "bool.off": "Off",
  "report_form.submit": "Submit",
  "report_form.submit_sub": "Save the entered values",
  "report_form.submitting": "Submitting…",
  "report_form.cancel": "Cancel",
  "report_form.cancel_sub": "Values will not be saved",
  "report_form.already_completed": "This slot is already completed.",
  "report_form.no_slot": "No open slot.",
  "report_form.offline_title": "Turbine is stopped",
  "report_form.offline_hint": "The entry will still be saved, but flagged in orange so reviewers see it was logged while the turbine was idle.",

  // ---------- Emergency form ----------
  "emergency.title": "🚨 Emergency",
  "emergency.intro": "Unplanned entry. KW and a reason are required; other indicators are optional. Admins will be notified after submit.",
  "emergency.reason_label": "Reason",
  "emergency.reason_placeholder": "Describe what happened",
  "emergency.reason_required": "Required field",
  "emergency.submit_sub_ok": "Save and notify administrators",
  "emergency.submit_sub_disabled": "Provide a reason first",
  "emergency.show_extras": "Fill remaining fields (optional)",
  "emergency.hide_extras": "Hide remaining fields",
  "emergency.landing_what": "What is «Emergency»?",
  "emergency.landing_when": "Use this ONLY for real abnormal events — failure, surge, leak, etc.",
  "emergency.landing_warn": "If you just want to log routine readings — close this tab and use «📝 Report».",
  "emergency.landing_btn": "Create emergency entry",
  // ---------- Files tab ----------
  "tabs.files": "Files",
  "files.title": "Recent files",
  "files.hint": "Tap a file — «Telemetry» opens on exactly its period.",
  "files.open": "Open analysis",
  "files.rows": "rows",
  "files.uploaded": "uploaded",
  "files.all_title": "All uploaded files",
  "files.f_all": "All",
  "files.new_rows": "new rows: {n}",
  "files.repeat": "repeat — everything was already stored",
  "files.none": "No uploaded files yet.",
  "files.row_hint": "Tap a row to open it in «Telemetry».",
  "auto.tf_file": "File",

  // ---------- Период и отчёт PDF (Автоматика v2) ----------
  "tabs.telemetry": "Telemetry",
  "telemetry.src_pa": "Meter",
  "period.decimal": ".",
  "period.title": "Period",
  "period.quick": "Quick",
  "period.by_file": "By file",
  "period.custom": "Custom period — to the second",
  "period.from": "from",
  "period.to": "to",
  "period.duration": "Duration",
  "period.apply": "Apply",
  "period.bad": "End is before start",
  "period.change": "Change period",
  "period.file": "file",
  "period.tables": "tables",
  "period.coverage": "Data {s}",
  "period.s": "s",
  "period.h": "h",
  "period.q_all": "All data",
  "period.q_7d": "7 days",
  "period.q_3d": "3 days",
  "period.q_24h": "24 h",
  "period.q_12h": "12 h",
  "period.q_6h": "6 h",
  "period.q_1h": "1 h",
  "period.q_lastday": "Last day with data",
  "period.dur_s": "{n} s",
  "period.dur_min": "{n} min",
  "period.dur_h": "{n} h",
  "period.dur_d": "{n} d",
  "period.step_sec": "per second",
  "period.step_min": "per minute",
  "period.step_5min": "per 5 min",
  "period.step_15min": "per 15 min",
  "period.step_hour": "hourly",
  "period.step_6h": "per 6 h",
  "period.step_day": "daily",
  "report.pdf_title": "PDF report",
  "report.includes": "What's included",
  "report.metrics": "metrics",
  "report.i1": "Key figures of the period, reactive energy: delivered / absorbed",
  "report.i2": "Charts: voltage, current, P, Q, frequency, cos φ, distributor, bearings and oil unit",
  "report.i3": "Tables: distributor → voltage → current → cos φ → P & Q → the rest",
  "report.i4": "All 43 metrics: start, min, avg, max, end",
  "report.i5": "Deviations: voltage outside {lo}–{hi} kV, frequency, stops and starts",
  "report.no_analysis": "Figures, charts and tables only — no interpretation.",
  "report.send": "Send to the bot chat",
  "report.full": "Tables for all 43 metrics (parts 2–3)",
  "report.make": "Build PDF",
  "report.making": "Building the PDF… usually 3–10 seconds",
  "report.done": "Done",
  "report.pages": "pages",
  "report.rows_step": "{n} rows {step}",
  "report.sent": "Sent to the bot chat",
  "report.not_sent": "Could not send to the chat: {err}",
  "report.open": "Open in browser",
  "report.send_now": "Send to Telegram",

  // ---------- Главная / События / Отчёты / Управление (шаг 3) ----------
  "tabs.home": "Home",
  "tabs.events": "Events",
  "tabs.reports": "Reports",
  "tabs.admin": "Manage",
  "home.title": "Paranda HPP",
  "home.peak": "Peak power",
  "home.energy": "Total energy",
  "home.run": "Under load",
  "home.coverage": "What data exists",
  "home.open_telemetry": "to telemetry",
  "home.last_data": "Latest data",
  "home.alarms": "Alarms",
  "home.unit_day": "run {run} · max {kw} kW",
  "home.events": "Latest events",
  "home.all": "all",
  "home.no_events": "No stops or voltage dips in the data.",
  "home.ev_trip": "G{u} tripped under {kw} kW",
  "home.ev_stop": "G{u} stop ({kw} kW before it)",
  "home.ev_dip": "G{u} voltage dip to {kv} kV, {s} s",
  "home.ev_below": "below 18 kV for {s} s",
  "home.events_hint": "Found in telemetry: stops (power → 0) and voltage dips below {kv} kV under load. Tap to open telemetry ±45 s.",
  "home.reports": "Recent reports",
  "events.sub_incidents": "Case studies",
  "events.sub_spikes": "Spikes",
  "reports.current": "Selected in telemetry",
  "reports.new_pdf": "New PDF for the period",
  "reports.generated": "Generated PDFs",
  "reports.none": "None yet — tap «New PDF for the period».",
  "reports.made": "built",
  "reports.sent": "sent to the chat",
  "reports.excel": "Excel for the selected period",
  "admin.sub_data": "Data",

  // ---------- События: лента и карточка (шаг 4) ----------
  "events.sub_feed": "Feed",
  "events.k_all": "All",
  "events.k_trip": "Trips",
  "events.k_dip": "Voltage dips",
  "events.k_stops": "Stops and starts",
  "events.k_alarm": "Alarms",
  "events.k_case": "Case studies",
  "events.u_all": "All",
  "events.none": "No events match these filters.",
  "ev.trip": "G{u} tripped under {kw} kW",
  "ev.stop": "G{u} stop ({kw} kW before it)",
  "ev.start": "G{u} start",
  "ev.start_sub": "{kw} kW a minute later",
  "ev.dip": "G{u} voltage dip to {kv} kV, {s} s",
  "ev.below": "below {kv} kV for {s} s",
  "ev.active": "active",
  "ev.acked": "acknowledged",
  "ev.case": "Case study: {u} trip, {d} {h}",
  "ev.case_sub": "per-second table and alarms",
  "ev.chart_u": "voltage RS / ST / RT, kV (±60 s)",
  "ev.chart_p": "active power, kW",
  "ev.no_telemetry": "No telemetry for this moment.",
  "ev.alarms_around": "Alarms ±5 min",
  "ev.open_case": "Open the case study",
  "ev.open_telemetry": "Open in telemetry",

  // ---------- Управление: Нормы и Система (шаг 5) ----------
  "admin.sub_norms": "Norms",
  "admin.sub_system": "System",
  "norms.intro": "Thresholds the app uses to find events and flag deviations. One setting applies to every section and to the PDF reports.",
  "norms.g_voltage": "Voltage 20 kV",
  "norms.g_trips": "Trips",
  "norms.g_freq": "Frequency",
  "norms.g_spikes": "Voltage spikes",
  "norms.g_history": "Change history",
  "norms.v_band": "Voltage corridor",
  "norms.v_dip": "Voltage dip",
  "norms.trip_s": "Trip or stop",
  "norms.f_band": "Frequency band",
  "norms.sharp_kv": "Sharp jump",
  "norms.prolonged_s": "Prolonged excursion",
  "norms.v_band_val": "{lo}–{hi} kV",
  "norms.v_dip_val": "below {v} kV",
  "norms.trip_s_val": "faster than {v} s",
  "norms.f_band_val": "{lo}–{hi} Hz",
  "norms.sharp_kv_val": "from {v} kV in 1 s",
  "norms.prolonged_s_val": "from {v} s",
  "norms.v_band_sub": "outside the corridor under load: G1 {g1} % of minutes, G2 {g2} %",
  "norms.v_dip_sub": "{pct} % of 20 kV, under load, longer than 2 s · dips now: {n}",
  "norms.trip_s_sub": "load fell to zero faster — a trip, slower — a planned stop · now {trips} trips and {stops} stops",
  "norms.f_band_sub": "outside the band under load: G1 {g1} min, G2 {g2} min",
  "norms.sharp_kv_sub": "a voltage jump between adjacent seconds",
  "norms.prolonged_s_sub": "voltage outside the corridor without a break",
  "norms.w_band": "Corridor",
  "norms.w_feed": "Event feed",
  "norms.w_pdf": "PDF",
  "norms.changed": "changed",
  "norms.default_is": "default {v}",
  "norms.history_empty": "No norm has been changed yet — the defaults apply.",
  "norms.revert": "Revert",
  "norms.footer": "After a norm is saved the events are re-detected, in about a second. PDFs already made stay as they are: each one states the norms it was made with.",
  "norms.saved": "Saved",
  "norms.saved_rebuilt": "Saved, events re-detected",
  "norms.undo": "Undo",
  "norms.done_dips": "Dips now: {n}.",
  "norms.done_trips": "Now {trips} trips and {stops} stops.",
  "norms.threshold": "Threshold",
  "norms.lower": "Lower bound",
  "norms.upper": "Upper bound",
  "norms.u_kv": "kV",
  "norms.u_s": "s",
  "norms.u_hz": "Hz",
  "norms.pct_nominal": "{p} % of 20 kV",
  "norms.bad_range": "The lower bound must be below the upper one.",
  "norms.now": "Now",
  "norms.if_saved": "If saved",
  "norms.counting": "Counting…",
  "norms.counting_slow": "Counting over every second, up to 10 s…",
  "norms.computed_on": "Counted over all G1 and G2 data.",
  "norms.save": "Save",
  "norms.save_rebuild": "Save and re-detect events",
  "norms.saving": "Saving…",
  "norms.unchanged": "No changes",
  "norms.reset": "Back to default: {v}",
  "norms.pv_dips": "Dips",
  "norms.pv_trips": "Trips",
  "norms.pv_stops": "Stops",
  "norms.pv_band": "Outside the corridor, % of loaded minutes",
  "norms.pv_freq": "Outside the band, loaded minutes",
  "norms.pv_sharp": "Sharp seconds",
  "norms.pv_prolonged": "Prolonged excursions",
  "norms.v_band_desc": "Line voltage under load should stay inside the corridor. Minutes when any phase leaves it are marked in telemetry, the corridor view, spikes, case studies and the PDF.",
  "norms.v_dip_desc": "Line voltage below the threshold under load for more than 2 s. Dips less than 2 minutes apart count as one.",
  "norms.trip_s_desc": "If the load fell to zero faster than this it is a trip (a breaker opened); slower — a planned stop (the guide vanes closing).",
  "norms.f_band_desc": "Frequency under load; minutes outside the band are counted in the «Deviations» part of the PDF report.",
  "norms.sharp_kv_desc": "The jump in line voltage between adjacent seconds from which a second counts as sharp (the Spikes view).",
  "norms.prolonged_s_desc": "How many seconds in a row the voltage (phase ST) must stay outside the corridor for an excursion to count as prolonged (the Spikes view).",
  "norms.v_band_std": "that is 20 kV ± 5 %.",
  "norms.v_dip_std": "that is 90 % of nominal — the dip definition of GOST 32144 / EN 50160.",
  "system.at": "Status at {t}, station time",
  "system.refresh": "Refresh",
  "system.services": "Services",
  "system.svc_bot": "Bot @{bot}",
  "system.svc_api": "App (API)",
  "system.svc_db": "Database",
  "system.svc_web": "Website and HTTPS",
  "system.running": "running",
  "system.down": "down",
  "system.since": "since {t}",
  "system.cert": "certificate until {d}, renews itself",
  "system.restart_hint": "Station time. If the database and the website restarted together at night, that was an automatic security update of the server, not a failure.",
  "system.server": "Server",
  "system.disk": "Disk",
  "system.mem": "Memory",
  "system.load": "CPU load",
  "system.cores": "{n} cores",
  "system.uptime": "Since reboot",
  "system.uptime_v": "{d} d {h} h",
  "system.of": "{a} of {b}",
  "system.db": "Database · {size}",
  "system.g_v2_sec": "G1/G2 telemetry, per second",
  "system.g_v2_min": "G1/G2 telemetry, per minute",
  "system.g_old": "Old SCADA tables",
  "system.g_old_sub": "already copied into G1, the app does not read them",
  "system.g_pa": "Meter (Power Analyzer)",
  "system.g_other": "Alarms, events, users, reports",
  "system.rows": "≈{n} rows",
  "system.rows_m": "≈{n} M rows",
  "system.last_import": "Latest file — {f}, data up to {to}.",
  "system.analyzed": "Query statistics updated {t}.",
  "system.backups": "Backups",
  "system.no_backup": "No backups",
  "system.timer_off": "Nightly backup is off",
  "system.last_failed": "The last backup failed — see the server log",
  "system.last_ok": "Last good one — {t}, {size}",
  "system.k_db": "Whole database",
  "system.k_full_set": "Full set: database, code, settings",
  "system.k_v2_tables_step": "G1/G2 tables before step 2",
  "system.k_v2_tables_import": "G1/G2 tables before a file upload",
  "system.k_v1_tables": "Old SCADA tables before removal",
  "system.k_other": "Other dump",
  "system.nightly": "Nightly backup",
  "system.nightly_on": "at 03:00 station time, kept 14 days · next {t}",
  "system.nightly_off": "off — switch it on to save the database every night",
  "system.free": "{v} free",
  "system.backup_now": "Back up now",
  "system.backup_running": "Backing up… about a minute",
  "system.backup_done": "Backup done: {size}",
  "system.backup_failed": "The backup failed — see the server log",
  "system.reports": "Reports and events",
  "system.pdf": "PDF reports",
  "system.pdf_sub": "{n} made · files older than {d} days are removed",
  "system.events": "Events",
  "system.events_sub": "trips, stops, starts, dips · detected {t}",
  "system.rebuild": "Re-detect events",
  "system.rebuilt": "Re-detected: {n} events",
  "u.mb": "MB",
  "u.gb": "GB",
  // ---------- 03.10.2026: reactive energy, chart sets, PDF row step and events ----------
  "auto.kpi_react": "Reactive energy",
  "auto.react_out": "delivered to grid · Q > 0",
  "auto.react_in": "absorbed · Q < 0",
  "auto.react_hint": "Q > 0 — the generator delivers reactive power to the grid, Q < 0 — it absorbs it from the grid.",
  "auto.kvarh": "kvarh",
  "auto.mvarh": "Mvarh",
  "home.react": "Reactive: delivered {out} · absorbed {inn} {u}",
  "charts.set": "Set",
  "charts.set_one": "One metric",
  "charts.set_bearings": "Bearings",
  "charts.set_oil": "Oil unit",
  "charts.set_windings": "Windings",
  "charts.set_hydraulics": "Hydraulics",
  "charts.set_hint": "Grey — the unit was stopped. Temperatures and oil pressures are shown during stops too.",
  "charts.set_under_load": "Under load",
  "report.step": "Table row step",
  "report.step_auto": "Auto",
  "report.step_hint": "Auto — as before: at most 120 rows. Any step is allowed while the table has at most 3,600 rows (per second — up to 1 hour).",
  "report.step_off": "Faded — more than 3,600 rows: narrow the period. Per-second data for a long period — Excel in Reports (admin).",
  "report.rows_n": "{n} rows",
  "report.many": "Many pages. Without parts 2–3 it will be ≈ {n} pages.",
  "report.events": "Starts and trips",
  "report.ev_counts": "in the period: trips — {trip}, stops — {stop}, starts — {start}, dips — {dip}",
  "report.ev_none": "no events in the period",
  "report.i6": "Events: starts, trips, stops, voltage dips — with the station alarms around them",
  "report.making_big": "Building a large PDF… up to 2–3 minutes",
  "period.step_10s": "per 10 seconds",
  // ---------- 03.10.2026, step 2: uploads with a preview ----------
  "up.title": "Upload data",
  "up.hint": "A G1/G2 station report (.csv, .gz), a meter file (.xlsx), the alarm journal (.csv) or a .zip of such files. First I show what is inside and what is already stored — nothing is written until you press the button.",
  "up.reading": "Reading the file… a big archive takes up to a minute",
  "up.items": "What is in the file",
  "up.kind_nounit": "G1 or G2?",
  "up.kind_meter": "Meter",
  "up.kind_alarms": "Alarm journal",
  "up.kind_unknown": "not recognised",
  "up.rows": "{n} rows",
  "up.alarm_rows": "{n} entries",
  "up.new": "new: {n}",
  "up.in_db": "already stored: {n}",
  "up.clock_moved": "file times («;» export) moved to station time: {shift}",
  "up.clock_as_is": "file times are station time already — not moved",
  "up.clock_check": "against the stored journal: {a} match with the shift, {b} without",
  "up.clock_by_journal": "as the alarm journal of this upload",
  "up.pick_unit": "Which generator?",
  "up.more_days": "and {n} more days",
  "up.legend_new": "new",
  "up.legend_part": "partly stored",
  "up.legend_db": "already stored",
  "up.legend_none": "not in the file",
  "up.how": "How to load",
  "up.mode_missing": "Only what is missing",
  "up.mode_missing_sub": "what is stored already stays as it is",
  "up.mode_replace": "Replace the period",
  "up.mode_replace_sub": "within the file, the stored data of the period is deleted and taken from the file",
  "up.range": "Period to load — the whole file by default, can be narrowed to the second",
  "up.need_unit": "Pick the generator for files without G1/G2 in their name — otherwise they are skipped.",
  "up.nothing": "Everything in the file is already stored — nothing to load.",
  "up.go": "Load",
  "up.go_new": "Load the new data: {n} rows",
  "up.running": "Loading… you can close the screen — it runs on the server",
  "up.done": "Done",
  "up.again": "Upload another file",
  "up.st_running": "loading",
  "up.st_done": "{n} rows loaded",
  "up.st_events": "events found: {n}",
  "up.st_nothing": "everything was stored already",
  "up.st_error": "error",
  "up.st_skip": "skipped",
  "up.st_ready": "queued",
  "up.alarms_title": "Station alarm journal",
  "up.alarms_cover": "{n} entries stored: {from} → {to}",
  "up.src_alarms": "Alarm journal",
  "up.src_hint": "The choice sets the generator for reports without G1/G2 in their name and the history below; an archive may mix any files.",
  // ---------- 03.10.2026, step 3: the bot takes files ----------
  "users.right_upload": "Data upload through the bot",
};
